export default __webpack_public_path__ + "static/reward-3-f0b041ac7596f9f222abc8861c489f3f.png";